import ruleData from "@/views/rules.json";//引入josn文件
import bus from '@/assets/js/bus';
import { Decimal } from 'decimal.js';
import { getLanguage,setLanguage} from '@/assets/js/config';
import { Message } from 'element-ui'
export default {
    install(Vue) {
        Vue.prototype.showLanguageDialog = function(msg){bus.$emit('showLanguageDialog',msg);}

        Vue.prototype.showLoadingBox = function(){bus.$emit('showLoadingBox');}
        Vue.prototype.hideLoadingBox = function(){bus.$emit('hideLoadingBox');}

        Vue.prototype.showPayPwdDialog = function(){bus.$emit('showPayPwdDialog');}
        Vue.prototype.hidePayPwdDialog = function(){bus.$emit('hidePayPwdDialog');}

        Vue.prototype.showConnectWalletBox = function(msg){bus.$emit('showConnectWalletBox',msg);}
        Vue.prototype.hideConnectWalletBox = function(){bus.$emit('hideConnectWalletBox');}

        Vue.prototype.showConfirmBox = function(type,token1,token2){
            if(!token1){
                token1 = "";
            }
            if(!token2){
                token2 = "";
            }
            bus.$emit('showConfirmBox',{type:type,token1:token1,token2:token2});
        }
        Vue.prototype.hideConfirmBox = function(msg){bus.$emit('hideConfirmBox',msg);}
        Vue.prototype.setConfirmBox = function(type){bus.$emit('setConfirmBox',type);}

        Vue.prototype.showMessageDialog = function(msg){bus.$emit('showMessageDialog',msg);}
        Vue.prototype.hideMessageDialog = function(msg){bus.$emit('hideMessageDialog',msg);}

        Vue.prototype.showBindParentBox = function(){bus.$emit('showBindParentBox');}
        Vue.prototype.hideBindParentBox = function(){bus.$emit('hideBindParentBox');}

        Vue.prototype.showNoticeBox = function(){bus.$emit('showNoticeBox');}
        Vue.prototype.hideNoticeBox = function(){bus.$emit('hideNoticeBox');}

        Vue.prototype.getUrlParms = function(name) {
            let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
            let r = window.location.search.substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return null;
        };

        Vue.prototype.formatTimestamp = function(timestamp,fmt) {
            if(timestamp == 0 || timestamp == null || timestamp == "" || timestamp == undefined){
                return "";
            }
            let date = new Date(timestamp);
            if(!fmt){
                fmt = "yyyy-MM-dd hh:mm:ss";
            }
            return this.formatDate2(date,fmt);
        }
        Vue.prototype.formatDate =  function(date) {
            let fmt = "yyyy-MM-dd hh:mm:ss";
            return this.formatDate2(date,fmt);
        }
        Vue.prototype.formatDate2 =  function(date, fmt) {
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
            }
            let o = {
                'M+': date.getMonth() + 1,
                'd+': date.getDate(),
                'h+': date.getHours(),
                'm+': date.getMinutes(),
                's+': date.getSeconds()
            };
            for (let k in o) {
                if (new RegExp(`(${k})`).test(fmt)) {
                    let str = o[k] + '';
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
                }
            }
            return fmt;
        }
        Vue.prototype.toDecimalVal = function(val,xs){
            if(val == null || val == undefined){
                return 0;
            }
            let str = new Decimal(val).toFixed(xs,Decimal.ROUND_DOWN);
            if (!(/^[0-9.]+$/g.test(str))) return '0';
            while (str.includes(".") && (str.endsWith('.') || str.endsWith('0'))) {
                str = str.slice(0, -1)
            }
            return str;
        }
        Vue.prototype.listToMap = function(array, keyName,valueName){
            let map = {};
            array.forEach(function (item) {
                map[item[keyName]] = item[valueName];
            });
            return map;
        };
        Vue.prototype.listToMap = function(array, keyName){
            let map = {};
            if(array){
                array.forEach(function (item) {
                    map[item[keyName]] = item;
                });
            }
            return map;
        };
        Vue.prototype.getUrlCode = function(){
            let queryCode = this.$route.query.code;
            if(queryCode){
                return queryCode;
            }
            let urlParam = this.getUrlParms("code");
            if(urlParam){
                return urlParam;
            }
            return "";
        }
        Vue.prototype.goHome = function(){
            if (this.$router.currentRoute.path == "/"){
                return;
            }
            let urlCode = this.getUrlCode();
            if(urlCode){
                this.$router.push({path:"/",query:{code:urlCode}});
            }else{
                this.$router.push({path:"/"});
            }
        }
        Vue.prototype.goPage = function(path){
            let urlCode =this.getUrlCode();
            if(urlCode){
                this.$router.push({path:path,query:{code:urlCode}});
            }else{
                this.$router.push({path:path});
            }
        }
        Vue.prototype.groupBy = function(array, name){
            let groups = {};
            array.forEach(function (item) {
                 let group = item[name];
                 groups[group] = groups[group] || [];
                 groups[group].push(item);
            });
            return groups;
        };
        

        Vue.prototype.isMobile =  function() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
            return flag;
        }


        Vue.prototype.getRuleInfo = function(ruleName){
            let lang = this.$i18n.locale;
            if(ruleData[ruleName][lang]){
                return ruleData[ruleName][lang];
            }else{
                return ruleData[ruleName]["zh_cn"];
            }
        }

        Vue.prototype.goHash = function(txHash){
            let url = this.getChainScan()+"tx/"+txHash;
            window.open(url,"_blank");
        }

        Vue.prototype.jsonToHexStr = function(str){
            str = unescape(encodeURIComponent(str));
            let bytes = [];
            for (let i = 0; i < str.length; i++){
                bytes.push(str.charCodeAt(i) & 0xFF);
            }
            let res = "0x";
            for (let i = 0; i < bytes.length; i++) {
                let tmp;
                let num=bytes[i];
                if (num < 0) {
                  tmp =(255+num+1).toString(16);
                } else {
                  tmp = num.toString(16);
                }
                if (tmp.length == 1) {
                  tmp = "0" + tmp;
                }
                res += tmp;
            }
            return res;
        }
        
        Vue.prototype.hexStrToJson = function(str) {
            if(str.startsWith("0x")){
                str = str.substr(2);
            }
            let len = str.length;
            if (len % 2 != 0) {
                return null;
            }
            let pos = 0;
            len /= 2;
            let bytes = new Array();
            for (let i = 0; i < len; i++) {
                let s = str.substr(pos, 2);
                let v = parseInt(s, 16);
                bytes.push(v);
                pos += 2;
            }
            let res = [];
            for (let i = 0; i < bytes.length; i++){
                res.push(String.fromCharCode(bytes[i]));
            }
            return res.join("");
        }

        Vue.prototype.getLanguage = function() {
            return getLanguage();
        }
        Vue.prototype.onCopy = function() {
            let msg = getLanguage() == "zh_cn"?"复制成功":"Copy successful";
            Message.success({message: msg,duration: 600})
        }

        Vue.prototype.langReplace = function(text,param) {
            return text.replace("{}",param);
        }
    }
}

  